export default {
  supplierpartners: {
    subtitle: "شركاء الموردين",

    title1: "موثوق من قبل",
    title2: "أفضل الموردين",

    desc:
      "من المنتجين المحليين إلى الموزعين الكبار، يثق الموردون عبر مختلف الفئات في ماهال لتنمية أعمالهم والوصول إلى المطاعم على نطاق واسع.",

    metric1: "مورد نشط",
    metric2: "مطاعم مخدومة",
    metric3: "طلبات يومية",

    cta: "انضم كمورد",
  },
};